/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import "./AssignmentCard.styles.scss";
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AssignmentIcon } from "components";
import { Icon, Button, GroupNameTag } from "components";
import { useCurrentUser, useGetGroups as getGroups } from "utils/hooks";
import { Assignment, Section, Group } from "types";
import getLastSubmission from "./utils/getLastSubmission";
import { useTranslation } from "react-i18next";
import { isGroupActive } from "utils/helpers";
import useCardButtons from "./components/CardButtons";

interface AssignmentCardProps {
  assignment: Assignment | Section;
  submissions?: any;
  onCardClick?: () => void;
  onRemoveClick?: () => void;
  onFillInClick?: () => void;
  onScheduleClick?: () => void;
  onPreviewClick?: () => void;
  onConfigureClick?: () => void;
  onShareClick?: () => void;
  isActive: boolean;
  showSubtitle: boolean;
  subtitle?: React.ReactNode;
  hasActions?: boolean;
  isExpired?: boolean;
  category?: "WORKSHEET" | "INFOSHEET" | "ASSESSMENT";
}

const AssignmentCard = ({
  assignment,
  submissions,
  onCardClick,
  onRemoveClick,
  onFillInClick,
  onScheduleClick,
  onPreviewClick,
  onConfigureClick,
  onShareClick,
  isActive,
  showSubtitle,
  subtitle,
  isExpired = false,
  category,
}: AssignmentCardProps) => {
  const { isTherapist, isPatient } = useCurrentUser();
  const [showBtns, setShowBtns] = useState(false);

  const isAssignment = (obj: Assignment | Section): obj is Assignment => {
    return "actionPlanId" in obj;
  };

  let group: Group | null = null;

  if (isAssignment(assignment) && assignment?.groupId) {
    const { specificGroup } = getGroups({
      groupId: assignment.groupId,
    });

    group = specificGroup;
  }

  const { uuid, slug, groupStatus } = useParams();

  const navigate = useNavigate();

  const filteredSubmissions = (function () {
    if (submissions && submissions.length > 0) {
      return submissions.filter(
        (el: any) => el.assignmentLabel === assignment.label
      );
    } else {
      return [];
    }
  })();

  const getUrl = () =>
    group
      ? `/groups/${groupStatus}/${uuid}/${slug}/${assignment.label
          .split(" ")
          .join("+")}`
      : `/patients/${uuid}/${slug}/${assignment.label.split(" ").join("+")}`;

  const { t } = useTranslation(["common"]);

  const isSimplified = assignment.type === "SAFETY_PLAN";
  const isConfigurable = category !== "INFOSHEET";

  const isGroupActiveOrNoGroup = group ? isGroupActive(group) : true;

  const { filteredButtons } = useCardButtons({
    filteredSubmissions,
    isGroupActiveOrNoGroup,
    isSimplified,
    isConfigurable,
    onRemoveClick,
    onFillInClick,
    onScheduleClick,
    onConfigureClick,
    onPreviewClick,
    onShareClick,
  });

  return (
    <div
      className={`assignment-card ${
        isActive ? "assignment-card__active" : ""
      } ${isExpired ? "assignment-card__expired" : ""} ${
        isSimplified ? "assignment-card__simplified" : ""
      }`}
      onClick={() => {
        if (showBtns) setShowBtns(false);
        onCardClick && onCardClick();
      }}
      id={assignment.slug}
    >
      <div className="assignment-card_title">
        {isAssignment(assignment) && (
          <AssignmentIcon
            icon={assignment.icon?.src}
            style={assignment.type}
            color={assignment.color}
          />
        )}
        <div className="assignment-card_container">
          <div className="assignment-card_left">
            <div className="assignment-card_label">{assignment.label}</div>
            {isPatient && isAssignment(assignment) && group?.name && (
              <GroupNameTag groupName={group.name} />
            )}
            {isTherapist && submissions && filteredSubmissions.length !== 0 && (
              <div className="assignment-card_last-subm">
                {t("submissions.last_submission_label")}:{" "}
                {getLastSubmission(filteredSubmissions)}
              </div>
            )}

            {/* Button shows the submissions quantity for this assignment and leads to page with submissions table */}
            {isTherapist && filteredSubmissions.length !== 0 && (
              <Button
                value={`${filteredSubmissions.length} ${
                  filteredSubmissions.length === 1
                    ? t("submissions.submission_label")
                    : t("submissions.submissions_label")
                }`}
                name="assignment-card_submissions"
                extraClass="assignment-card_submissions"
                onClick={() => navigate(getUrl())}
              />
            )}
          </div>

          <div className="assignment-card_right">
            {showSubtitle && (
              <div className="assignment-card_subtitle">{subtitle}</div>
            )}

            {/* Buttons to work with this assignment  */}
            <div
              className="assignment-card_buttons"
              style={{ display: isTherapist ? "flex" : "none" }}
            >
              {filteredButtons?.map(
                (button, index) =>
                  index < 3 && (
                    <Button
                      key={button.name}
                      value={
                        <>
                          <Icon src={button.icon} />
                          <span>{button.value}</span>
                        </>
                      }
                      name={button.name}
                      extraClass={button.style}
                      onClick={button.onClick}
                    />
                  )
              )}
              {
                <div className="extra_btns">
                  {filteredButtons?.map(
                    (button, index) =>
                      index >= 3 && (
                        <Button
                          key={button.name}
                          value={
                            <>
                              <Icon src={button.icon} />
                              <span>{button.value}</span>
                            </>
                          }
                          name={button.name}
                          extraClass={`
                        ${button.style} ${
                            showBtns
                              ? "extra_btns--visible"
                              : "extra_btns--hidden"
                          }
                      `}
                          onClick={() => {
                            setShowBtns(false);
                            button.onClick && button.onClick();
                          }}
                        />
                      )
                  )}
                </div>
              }
              <Button
                name="assignment-card_btns"
                value={""}
                icon={"MenuDots"}
                extraClass="button-icon assignment-card_btns"
                onClick={() => setShowBtns(!showBtns)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentCard;
